import { useQuery } from 'react-query';
import {
  getBettieFeedPost,
  type GetBettieFeedPostResponse
} from '../../services/bettieFeedService';

export function useGetBettieFeedPost(chatRoomId: string, postId: string) {
  return useQuery<GetBettieFeedPostResponse, Error>(
    ['bettieFeedPost', chatRoomId, postId],
    () => getBettieFeedPost(chatRoomId, postId),
    {
      enabled: !!chatRoomId && !!postId,
      staleTime: 30 * 1000,
      cacheTime: 2 * 60 * 1000
    }
  );
}
